import {ReactElement} from 'react';
import AddIcon from '@mui/icons-material/Add';
import {Box, Button, Paper, SelectChangeEvent, Typography} from '@mui/material';
import {TFunction} from 'react-i18next';
import {Project} from 'interfaces/Project';
import SelectProject from '../SelectProject';

type Props = {
  t: TFunction;
  selectProjectForm: {
    value: string | null;
    options: Project[];
  };
  onSelectProject: (event: SelectChangeEvent) => void;
  onCreate: () => void;
};

export default function ProjectSidebar({
  t,
  selectProjectForm,
  onSelectProject,
  onCreate
}: Props): ReactElement {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'column',
        gap: 3
      }}
    >
      <Typography sx={{fontSize: 20, fontWeight: 500, lineHeight: 1.5, color: 'ctaBlack'}}>
        {t('common:myProjects')}
      </Typography>
      <SelectProject t={t} onSelectProject={onSelectProject} selectProjectForm={selectProjectForm} />
      <Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onCreate}
          sx={{bgcolor: 'ctaDark', '&:hover': {bgcolor: 'ctaDark'}}}
        >
          {t('common:createProject')}
        </Button>
      </Box>
    </Paper>
  );
}
